<template>
  <router-link :to="`/dashboard/jobs/${$route.params.id}/create`" class="add-job">
    <i class="el-icon-plus"/>
  </router-link>
</template>

<script>
export default {
  name: 'AddJob',
};
</script>

<style scoped lang="scss">
.add-job {
  font-size: 22px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/AddJob.vue